import React, {memo} from 'react';
import cn from 'classnames';

import CreateCtx from 'coreUtils/createCtx';

import CustomerServiceLinks from 'brandComponents/CustomerServiceLinks';
import ShowOrHideOnBreakpoint from 'brandComponents/Responsive/ShowOrHideOnBreakpoint';

import {useParsedNavigationProps} from '../NavigationItem/hooks';

import {IFlatNavigationItemProps, INavigationItemOldProps} from './IFlatNavigationItem';
import {FlatNavigationItemContent, FlatNavigationItemList} from './Subcomponents';

export const [useParentProvider, ParentProvider] = CreateCtx<IFlatNavigationItemProps>();

const FlatNavigationItem = (props: INavigationItemOldProps) => {
	const parent = useParentProvider(true);
	const parsedProps = useParsedNavigationProps({...props, parent});

	// Is a root navigation item, the main navigation itself, just render a UL
	if ((!parent?.id || parent?.id === parsedProps.id) && !parsedProps.title) {
		return (
			<ParentProvider value={parsedProps}>
				<FlatNavigationItemList
					level="root"
					classNames={cn('navigation', {
						'has-active': parsedProps.hasActive,
						'has-multi-sub-lists': !!parsedProps.hasSubLists,
					})}
				>
					{parsedProps.children}

					{!!parsedProps.isInHeaderContext && (
						<ShowOrHideOnBreakpoint classNames="navigation__service-links" as="li" query="<xx-large">
							<CustomerServiceLinks />
						</ShowOrHideOnBreakpoint>
					)}
				</FlatNavigationItemList>
			</ParentProvider>
		);
	}

	if (parsedProps.isFlatSubList) {
		return (
			<ParentProvider value={parsedProps}>
				<FlatNavigationItemList
					level="sub"
					viewAll={parsedProps.viewAll}
					classNames={cn(
						{active: parsedProps.isActive},
						{'has-active': parsedProps.hasActive},
						parsedProps['animationClasses'],
					)}
					isFlatSubList={parsedProps.isFlatSubList}
					title={parsedProps.title}
					editorialContent={parsedProps.editorialContent}
					customSettings={parsedProps.customSettings}
					showTrigger
					onTriggerClick={parsedProps.handleNavigationItemClick}
				>
					{parsedProps.children}
				</FlatNavigationItemList>
			</ParentProvider>
		);
	}

	// The final single navigation item
	return (
		<ParentProvider value={parsedProps}>
			<FlatNavigationItemContent {...parsedProps}>{parsedProps.children}</FlatNavigationItemContent>
		</ParentProvider>
	);
};

export default memo(FlatNavigationItem, () => true);
